import { track } from "@amplitude/analytics-react-native";
import { useQuery } from "@apollo/client";
import { useEffect, useRef } from "react";
import { amp } from "src/api/amplitude";
import GetGatheringForReadyInfoDocument from "src/api/graphql/__generated__/documents/GetGatheringForReadyInfoDocument";
import { useAsyncQuery } from "src/api/graphql/helper";
import { useGatheringStore } from "src/contexts/GatheringContext";
import { getClientId } from "src/helpers/globalHelpers";
import { alert } from "src/swsh-native";
import GlobalRefreshTopic from "src/topics/GlobalRefreshTopic";

const GatheringNotReadyPopUp = () => {
	const gatheringId = useGatheringStore((state) => state.gatheringId);
	const ownerId = useGatheringStore((state) => state.ownerId);
	const isOwner = ownerId === getClientId();
	const getGatheringReady = useAsyncQuery(GetGatheringForReadyInfoDocument);
	const { data } = useQuery(GetGatheringForReadyInfoDocument, {
		variables: {
			input: {
				gatheringId,
			},
		},
		skip: isOwner,
		fetchPolicy: "cache-only",
	});
	const didPrompt = useRef(false);

	useEffect(() => {
		(async () => {
			if (isOwner) return;
			if (didPrompt.current) return;
			// If waitingForInitialPhotos, then we fetch the newest data to make sure it still is
			if (
				data?.getGathering?.waitingForInitialPhotos === true ||
				data?.getGathering?.waitingForInitialPhotos == null
			) {
				const { data: newData } = await getGatheringReady({
					variables: {
						input: {
							gatheringId,
						},
					},
					fetchPolicy: "network-only",
				});

				if (newData?.getGathering?.waitingForInitialPhotos === true) {
					didPrompt.current = true;
					track(amp.gathering.gatheringNotReady.prompt);
					alert({
						title: "Album still processing",
						message:
							"Photos are still being processed, so you might not see all of them right away!",
						buttons: [
							{
								text: "Okay",
								style: "default",
								onPress: () => {
									track(amp.gathering.gatheringNotReady.okay);
								},
							},
							{
								text: "Reload",
								style: "cancel",
								onPress: () => {
									GlobalRefreshTopic.emit("refresh", {});
									track(amp.gathering.gatheringNotReady.reload);
								},
							},
						],
					});
				}
			}
		})();
	}, [data?.getGathering?.waitingForInitialPhotos, gatheringId, getGatheringReady, isOwner]);

	return null;
};
export default GatheringNotReadyPopUp;
